import { useEffect, useState } from 'react';
import { Card, CardEyebrow, CardTitle, EmptyState } from '@invested/ui';
import * as api from '../../services/api';
import type { DashboardSummary } from '../../types';

const Stat: React.FC<{ label: string; value: React.ReactNode; sub?: string }> = ({ label, value, sub }) => (
  <Card size="md">
    <CardEyebrow>{label}</CardEyebrow>
    <p className="mt-2 text-4xl font-semibold text-[color:var(--invested-text-primary,#0f172a)]">{value}</p>
    {sub && <p className="mt-1 text-xs text-[color:var(--invested-text-muted,rgb(15_23_42_/_0.55))]">{sub}</p>}
  </Card>
);

export function DashboardPage() {
  const [summary, setSummary] = useState<DashboardSummary | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .getDashboardSummary()
      .then(setSummary)
      .catch(() => setError(true));
  }, []);

  if (error) {
    return <EmptyState title="Fikk ikke lastet dashbord" description="Prøv å laste siden på nytt." />;
  }

  if (!summary) {
    return <p className="text-sm text-black/50">Laster…</p>;
  }

  return (
    <div className="space-y-6">
      <div>
        <CardTitle as="h1">Dashbord</CardTitle>
        <p className="mt-1 text-sm text-black/55">Status for DNAm-kalibreringsstudien.</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat
          label="Inkludert"
          value={`${summary.included} / ${summary.targetEnrollment}`}
          sub={`${summary.screening} i screening, ${summary.withdrawn} uttrukket`}
        />
        <Stat label="Prøver i fryser" value={summary.samplesStored} sub="Status STORED" />
        <Stat label="Prøver sendt" value={summary.samplesShipped} sub="Sendt eller analysert" />
        <Stat label="IDAT mottatt" value={summary.shipmentsWithIdatReceived} sub="Forsendelser med IDAT-dato" />
      </div>
    </div>
  );
}
